// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10.83 10.83L10.83 5.17L5.17 5.17M10.83 5.17L5.17 10.83',
];
